import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useDevTools } from "./DevToolsProvider";

export function DevToolsDrawer() {
  const {
    plugins,
    activePluginId,
    isDrawerOpen,
    isSidebarExpanded,
    setActivePlugin,
  } = useDevTools();
  const activePlugin = plugins.find((p) => p.id === activePluginId);

  const drawerClass = [
    "dt-drawer",
    isDrawerOpen && isSidebarExpanded ? "dt-drawer--open" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={drawerClass}>
      {activePlugin && (
        <>
          <div className="dt-drawer__header">
            <span className="dt-drawer__title">{activePlugin.name}</span>
            <button
              className="dt-drawer__close"
              onClick={() => setActivePlugin(null)}
              type="button"
              aria-label="Close"
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
          <div className="dt-drawer__content">{activePlugin.render()}</div>
        </>
      )}
    </div>
  );
}
